import { Account, Client } from 'appwrite';

const endpoint =
  import.meta.env.VITE_APPWRITE_ENDPOINT ||
  'https://sfo.cloud.appwrite.io/v1';

const projectId =
  import.meta.env.VITE_APPWRITE_PROJECT_ID || 'pixlieproduction';

let client: Client | null = null;
let account: Account | null = null;

export function getAppwriteClient(): Client {
  if (!client) {
    client = new Client().setEndpoint(endpoint).setProject(projectId);
  }
  return client;
}

export function getAppwriteAccount(): Account {
  if (!account) {
    account = new Account(getAppwriteClient());
  }
  return account;
}

export const appwriteConfig = { endpoint, projectId };
